import { API_TYPE, IResponse, fetchData } from "@umu/umu-fetch";
import { COURSE_ITEM_TYPE, EHomeworkType, ELearnStatus, ELiveType, EUserSetupType, LiveStatus, SESSION_TYPE } from "./enum";

interface IResponseData {
    data: any
}
export interface IResourceInfo {
    id: string;
    file_name: string;
    file_size: string;
    file_duration: string;
    url: string;
    ext: string;
    audio_weike: {
        audioDuration: string;
    }
    live_session_status: LiveStatus
    [key: string]: any
}

export interface IElementResource {
    resource_id: string;
    resource_type: number;
    resource_info: IResourceInfo
}
export interface IParticipateInfo {
    participate_status: number;
    accept_submission_time: number;
    refuse_submission_time: number;
}
export interface IQuizStatus {
    have_enough_questions: number;
}

export interface IElementSetup {
    type_name: string;
    homework_type: EHomeworkType;
    content_type: 'scorm' | string;
    advance: string;
    live_type: ELiveType;
}
export interface IElementExtend {
    is_draft: number;
    learn_status: ELearnStatus;
    lock: number;
    lock_type: number;
    user_used: number;
    session_in_use: number;
    result_card_view: string;
    point_ratiio: string;
    estimated_start_ts: number;
    estimated_participate_num: string;
    estimated_live_duration: number;
    subscribe_num: number;
    exam_full_mark: number;
    question_num: number;
    is_show_exam_ranking: number;
}
export interface IElementDistribStar {
    star: string;
    count: number;
}
export interface IElementStat {
    participate_num: string;
    finish_num: number;
    like_num: number;
    average_duration: number;
    average_score: number;
    student_average_score: string;
    teacher_score: string;
    student_is_score: string;
    teacher_is_score: string;
    full_marks: number;
    comment_num: number;
    question_num: number;
    average_star: number;
    people_count: string;
    distrib_star: IElementDistribStar;
    im_like_num: number;
    duration: number;
    highest_score: number;
    lowest_score: number;
    pass_mark_count: number;
    pass_mark_rate: number;
    pass_mark_score: number;
    play_num: number;

    submit_cnt: number;
    photo_num: number;
}
export interface IElement {
    access_permission: number;
    title: string;
    index: number;
    is_top: number;
    type: SESSION_TYPE;
    create_teacher_id: string;
    desc: string;
    is_require: number;
    element_id: number;
    chapter_id: number;
    auto_check: number;
    setup: IElementSetup;
    resource_arr: IElementResource[];
    parent_id: string;
    parent_type: number;
    share_url: string;
    share_pc_url: string;
    share_qrc: string;
    share_card_view: string;
    result_card_view: string;
    extend: IElementExtend;
    stat: IElementStat;
    trial_status: number;
    is_collected: number;
    participate_info: IParticipateInfo;
    quiz_status: IQuizStatus;
}
export interface IListResponse<T> {
    list: T[];
    page_info: {
        current_page: number;
        list_total_num: number;
        size: number;
        total_page_num: number;
    }
    [key: string]: any
}
export interface ICourseElement {
    id: string;
    type: number;
    item_type: COURSE_ITEM_TYPE;
    element_id: string;
    chapter_id: string;
    resource_arr: IElementResource[];
    is_collected: number;
    participate_info: IParticipateInfo;
    quiz_status: IQuizStatus;
    chapter_sessions: IListResponse<IElementListItem>;
    status: ELearnStatus;
    describe: string;
    lock: number;
    chapter_completion: {
        fold_chapter?: number;
        completion_rate: number;
        completion_status: ELearnStatus;
    }
}
export type IElementListItem = ICourseElement & IElement
export type IElementListResponse = IListResponse<IElementListItem>


export interface IElementListParams {
    get_draft: number;
    page: number;
    size: number;
    parent_id: string;
    key_word?: string;
}

const API_ELEMENT_LIST = '/napi/element/list';
/**
 * 获取课程小节列表 
 * http://yapi.umu.work/project/657/interface/api/11259
*/
export const getElementList = (params: IElementListParams): Promise<IElementListResponse> => {
    return fetchData({
        url: API_ELEMENT_LIST,
        type: API_TYPE.GET,
    }, params).then((data: IResponseData) => {
        return data.data
    });
};


export interface IChapterListParams {
    page: number;
    size: number;
    parent_id: string;
    get_draft: number;
    key_word?: string;
    chapter_id: string;
}
export type IChapterListResponse = IListResponse<IElement>


/**
 * 根据章节获取小节列表
 * http://yapi.umu.work/project/657/interface/api/11273
 */
export const API_CHAPTER_ELEMENT_LIST = '/napi/chapter/element-list';
export const getChapterElementList = (params: IChapterListParams): Promise<IChapterListResponse> => {
    return fetchData({
        url: API_CHAPTER_ELEMENT_LIST,
        type: API_TYPE.GET,
    }, params).then((data: IResponseData) => data.data);
};

export interface IUserUpdateSetupParams {
    option_type: EUserSetupType;
    option_value: number;
    option_obj_id: string
}
export interface IUserUpdateSetupResponse {
    setup: IUserUpdateSetupParams;
    umu_id: string;
}

// 更新配置通用接口
export const API_USER_UPDATE_SETUP = '/api/user/updatesetup';
export const updateUserSetup = (params: IUserUpdateSetupParams): Promise<IResponse<IUserUpdateSetupResponse>> => {
    return fetchData({ url: API_USER_UPDATE_SETUP, type: API_TYPE.POST }, params);
};


export interface ICourseInfoParams {
    group_id: string;
}
export interface ICourseCategory {
    id: string;
    name: string;
    name_i18n: string;
    sub_category: any[]
}
export interface ICourseGroupCount {
    content_length: number;
    like_num: number;
    participate_num: number;
    session_count: number;
    session_count_video: number;
    session_num: number;
    vote_count: number;
    vote_hide: number;
    weike_count: number;
    weike_durtion_secound: number;
    weike_hide: number;
}
export interface ICourseSetup {
    allowChat: number;
    allowReward: number;
    auto_show_review_card: number;
    hideSessionNav: number;
    is_emigrated: number;
    open_certificate: number;
    previewComments: number;
    show_banner: number;
    show_finish_trainees: number;
    show_session_index: number;
    skin_data: any;
    skin_id: string;
    themeColor: number;
    vlt_max: number;
}
export interface ICourseWeikeStat {
    averageStar: number;
    finish: number;
    like: number;
    like_num: number;
    participate: number;
}
export interface ICourseInfo {
    access_code: string;
    access_permission: string;
    address: string;
    allow_cancel_enroll: number;
    audio_status: string;
    bg_img: string;
    can_edit_content_type: number;
    category_arr: ICourseCategory[];
    city: string;
    contact: string;
    contactPhone: string;
    content_type: string;
    coursePersion: string;
    courseType: string;
    create_time: string;
    custom_head_img: boolean;
    customerName: string;
    desc: string;
    enroll_id: string;
    enroll_url: string;
    enterprise_certificate: {
        status: number;
    };
    enterprise_id: string;
    etime: string;
    eventType: string;
    groupId: string;
    groupRemark: string;
    groupTime: any[];
    groupTitle: string;
    group_count: ICourseGroupCount
    group_in_use: string;
    head_img: string;
    id: string;
    im_rid: string;
    im_room_setup: any[];
    is_assigned: number;
    is_in_trust: string;
    is_lock: string;
    is_repetitive_mode: string;
    is_top: number;
    isimportant: string;
    lession_type: string;
    likeQrc: string;
    likeUrl: string;
    max_online_user: string;
    max_user_count: string;
    message_close_status: number;
    other_content_type: string;
    other_lession_type: string;
    owner_enterprise_id: string;
    parent_obj_id: string;
    permission: string;
    point_isopen: number;
    province: string;
    rankQrc: string;
    rankUrl: string;
    release_detail_desc: string;
    release_status: string;
    remark: string;
    repetitive_course_lock: string;
    screen_enable: string;
    search_text: string;
    session_sort_flag: number;
    setup: ICourseSetup;
    sharePcUrl: string;
    shareQrc: string;
    shareUrl: string;
    share_card_view: string;
    show_pic: string;
    source: string;
    starQrc: string;
    starUrl: string;
    stime: string;
    tags: any[];
    teacher_id: string;
    title: string;
    town: string;
    trial_status: number;
    type: string;
    update_time: string;
    weike_stat: ICourseWeikeStat
    multimedia_id: string;
    multimedia_type: any;

    is_collected: number;
    creatorInfo: any
}
export const API_COURSE_INFO = '/napi/course/get-course-info';
export const getCourseInfo = (params: ICourseInfoParams): Promise<ICourseInfo> => {
    return fetchData({ url: API_COURSE_INFO, type: API_TYPE.GET }, params).then((data: IResponseData) => {
        return data.data
    });
};
